import { validateEmail } from "utils/validate";

export function validateUsernameInput(value: string): string | null {
    if (value.length < 1) {
        return "Fill field";
    }

    return null;
}

export function validateEmailInput(value: string): string | null {
    if (value.length < 1) {
        return "Fill field";
    }

    if (!validateEmail(value)) {
        return "Invalid email";
    }
    return null;
}

export function validatePasswordInput(value: string): string | null {
    if (value.length < 1) {
        return "Fill field";
    }

    return null;
}